/** @format */

import { BetDetails } from "../../components/BetDetails";
import { PotContriStats } from "../../components/PotContriStats";
import { ShowdownDetails } from "../../components/ShowdownDetails";
import PerformanceGrid from "../../components/PerformanceGrid";
import { MostPlayedStakes } from "../../components/MostPlayedStakes";
import { TopHands } from "../../components/TopHands";
import EmptyStats from "../../components/EmptyStats";
import { transformStats } from "../../../../../Common/utils/statsUtil";
import {
  gradient1,
  gradient2,
  gradient3,
  HUD_STATS_PROP_LBL_CLR_MAP,
  HUD_STATS_PROPS,
  STATS_CORNER_MESSAGE,
  statsCashConfig,
} from "@/src/constants/StatsCornerConstants";
import PlayPosition from "../../components/PlayPosition";
import { StealCheckRaiseSection } from "../../components/StealCheckRaiseSection";

export const CashGamesStats = ({ pageData }) => {
  const {
    hudStats,
    cashGameStats,
    mostPlayedStakes,
    bestHandData,
    flopSeenData,
  } = pageData || {};
  const hudStatsRadialBarArr = [HUD_STATS_PROPS.VPIP, HUD_STATS_PROPS.PFR];
  const hudStatsSegmentedProgressArr = [
    HUD_STATS_PROPS.WTSD,
    HUD_STATS_PROPS.WSD,
  ];
  const hudStatsRadialBarArr2 = [
    HUD_STATS_PROPS.THREE_BET,
    HUD_STATS_PROPS.FOLD_TO_THREE_BET,
    HUD_STATS_PROPS.C_BET,
    HUD_STATS_PROPS.FOLD_TO_C_BET,
  ];
  const hudStatsProgressBarArr = [
    HUD_STATS_PROPS.STEAL,
    HUD_STATS_PROPS.CHECK_RAISE,
  ];
  const displayStats = transformStats(cashGameStats, statsCashConfig);
  const gradientArr = [gradient1, gradient2, gradient3];

  return pageData && Object.keys(pageData).length > 0 ? (
    <div className="border-t-[0.0313rem] border-(--teal-700) rounded-t-xl">
      <div className="text-xs font-normal text-primary pt-2.5 flex justify-center gap-1.5">
        <span>🔥</span>
        <span>{STATS_CORNER_MESSAGE}</span>
      </div>

      {/* VPIP PFR SECTION */}
      <PotContriStats
        hudStatsRadialBarArr={hudStatsRadialBarArr}
        hudStats={hudStats}
        gradientArr={gradientArr}
      />

      {/* WTSD and WSD Section */}
      <ShowdownDetails
        hudStatsSegmentedProgressArr={hudStatsSegmentedProgressArr}
        hudStats={hudStats}
      />

      {/* Fold bet section */}
      <BetDetails
        hudStatsRadialBarArr2={hudStatsRadialBarArr2}
        hudStats={hudStats}
      />

      {/* Steal Check Raise section */}
      <StealCheckRaiseSection
        hudStats={hudStats}
        hudStatsProgressBarArr={hudStatsProgressBarArr}
      />

      {/* Cash Game Performance */}
      <PerformanceGrid title="Cash Game Performance" items={displayStats} />

      {/* Play by Position */}
      <PlayPosition
        title="Play by Position"
        data={flopSeenData}
        handPlayed={pageData?.cashGameStats?.handPlayed}
      />

      {/* MOST PLAYED STAKES */}
      <MostPlayedStakes mostPlayedStakes={mostPlayedStakes} />

      {/* Top 5 Hands */}
      <TopHands bestHands={bestHandData} />
    </div>
  ) : (
    <div className="h-full mt-24">
      <EmptyStats redirectTo="/cashLobby" />
    </div>
  );
};
